import React, { useEffect } from "react";
import {
  StyledClubPage,
  ProjectWrapper,
  InsightsWrapper,
  BreakdownInsightsWrapper,
  DoughnutWrapper,
} from "../styles/StyledClub";
import { useState } from "react";
import ClubProjectCard from "../components/ClubProjectCard";
import DoughnutChart from "../components/DoughnutChart";
import { fetchProjects, encode } from "../utils/api";
import { NoInstances } from "../styles/StyledProject";
import { Link } from "@reach/router";
import SpinningWheel from "../components/SpinningWheel";
import ErrorPopup from "../components/ErrorPopup";
function ClubProjects() {
  const [projects, setProjects] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [error, setError] = useState(null);
  let areas = [
    { variable: "peopleFirst", score: 0, title: "People", count: 0 },
    { variable: "techQuality", score: 0, title: "Tech", count: 0 },
    {
      variable: "commercialManagement",
      score: 0,
      title: "Commercial",
      count: 0,
    },
    { variable: "product", score: 0, title: "Product", count: 0 },
    { variable: "delivery", score: 0, title: "Delivery", count: 0 },
    {
      variable: "clientManagement",
      score: 0,
      title: "Client",
      count: 0,
    },
  ];

  useEffect(() => {
    const club = window.localStorage.getItem("club");
    const encoded = encode(club);
    fetchProjects(encoded)
      .then((response) => {
        setProjects(response);
        setFetched(true);
      })
      .catch((err) => {
        if (err) setError(err);
      });
  }, []);
  if (!fetched) {
    return <SpinningWheel />;
  }
  if (!projects || projects.length === 0) {
    return (
      <NoInstances>
        <h1>There are no projects yet</h1>
        <Link className="rag-btn" to={`/create-client`}>
          Create New
        </Link>
      </NoInstances>
    );
  }

  const analyseData = () => {
    for (const project of projects) {
      for (const instances of project.instances) {
        for (const [key, value] of Object.entries(instances)) {
          for (const area of areas) {
            if (key === area.variable) {
              for (const value1 of Object.values(value)) {
                if (value1) {
                  area.score += value1;
                  area.count++;
                }
              }
            }
          }
        }
      }
    }

    for (const area of areas) {
      area.score = parseInt((area.score / (area.count * 5)) * 100);
    }
  };

  analyseData();

  return (
    <StyledClubPage>
      {error && <ErrorPopup errors={error.response.data.errors} />}
      <h1>Club Insights</h1>
      <p className="health">Club Health Breakdown</p>
      <InsightsWrapper>
        <BreakdownInsightsWrapper>
          {areas.map((area, index) => {
            if (area.score)
              return (
                <DoughnutWrapper key={index}>
                  <DoughnutChart percentage={area.score} title={area.title} />
                </DoughnutWrapper>
              );
            else return <></>;
          })}
        </BreakdownInsightsWrapper>
      </InsightsWrapper>
      <div className="headers">
        <p className="project-name">Project Name</p>
        <p className="health">Overall Health</p>
      </div>
      <ProjectWrapper>
        {projects &&
          projects.map((proj, i) => {
            const { _id, clubName, clientName, instances, projectName } = proj;
            return (
              <ClubProjectCard
                key={i}
                id={_id}
                clubName={clubName}
                instances={instances}
                clientName={clientName}
                projectName={projectName}
              />
            );
          })}
      </ProjectWrapper>
    </StyledClubPage>
  );
}

export default ClubProjects;
